import { useCallback, useEffect, useRef } from 'react'
import { useAddAffiliateReferralCodeMutation } from '../../../graphql/generated/graphql'

const REFERRAL_STORAGE_KEY = 'REFERRAL_CODE'

export const useStoreReferralCode = () => {
    const referralCode = localStorage.getItem(REFERRAL_STORAGE_KEY)
    const initial = useRef(!!referralCode && referralCode.length > 0)

    const storeCode = (code: string) => {
        if (!code || code.length === 0) return
        localStorage.setItem(REFERRAL_STORAGE_KEY, code)
    }

    return {
        alreadyApplied: initial.current,
        storeCode,
        referralCode,
    }
}

export const useApplyReferralCode = () => {
    const called = useRef(false)
    const [addReferralCode] = useAddAffiliateReferralCodeMutation()

    const handleApplyCode = useCallback(
        async (code: string) => {
            await addReferralCode({ variables: { referralCode: code } })
            localStorage.removeItem(REFERRAL_STORAGE_KEY)
        },
        [addReferralCode]
    )

    useEffect(() => {
        if (called.current) return
        called.current = true

        const referralCode = localStorage.getItem(REFERRAL_STORAGE_KEY)
        if (!referralCode || referralCode.length === 0) return

        handleApplyCode(referralCode)
    }, [handleApplyCode])
}
